<template>
  <el-dialog class="add-user-modal" :title="title_name" width="600" v-model="is_show_add_modal" @close="close(false)">
    <div class="user-form-wrap" :class="{ 'is-error': is_error }">
      <!-- Email -->
      <div class="item-wrap" v-if="!is_edit">
        <div class="item-2">
          <label class="label">Email</label>
          <el-input
            v-model="values.email"
            placeholder="Email"
            :disabled="is_edit"
            @input="clearError('email')"
            :class="{ 'is-error': errors.email }"
          />
          <p class="error" v-if="errors.email"><span v-html="errors.email"></span><svg-icon name="alert" /></p>
        </div>
      </div>
      <div class="item-wrap" v-else>
        <div class="item-2">
          <label class="label">Email</label>
          <p class="value">{{ values.email }}</p>
        </div>
      </div>

      <!-- First Name / Last Name -->
      <div class="item-wrap item-wrap-2" v-if="!is_edit">
        <div class="item">
          <label class="label">First name</label>
          <el-input
            v-model="values.first_name"
            placeholder="First name"
            @input="clearError('first_name')"
            :class="{ 'is-error': errors.first_name }"
          />
          <p class="error" v-if="errors.first_name">{{ errors.first_name }}<svg-icon name="alert" /></p>
        </div>
        <div class="item">
          <label class="label">Last name</label>
          <el-input
            v-model="values.last_name"
            placeholder="Last name"
            @input="clearError('last_name')"
            :class="{ 'is-error': errors.last_name }"
          />
          <p class="error" v-if="errors.last_name">{{ errors.last_name }}<svg-icon name="alert" /></p>
        </div>
      </div>
      <div class="item-wrap" v-else>
        <div class="item-2">
          <label class="label">Name</label>
          <p class="value">{{ values.first_name + ' ' + values.last_name }}</p>
        </div>
      </div>

      <div class="item-wrap">
        <label class="label">Role</label>
        <el-select v-model="values.role_id" placeholder="Select" @change="changeRole">
          <el-option
            v-for="item in roles.filter((e) => e.role_type !== 100 && e.role_type !== 200)"
            default-first-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>

      <div class="item-wrap">
        <label class="label">Add to company/team</label>
        <el-select v-model="values.company_name" placeholder="Select" default-first-option @change="changeRole">
          <el-option v-for="item in companys" :key="item.id" :label="item.name" :value="item.name" />
        </el-select>
      </div>

      <!-- Buttons -->
      <div class="btn-wrap">
        <el-button v-if="is_can_delete" type="default" size="large" @click="deleteCreator"> Delete </el-button>
        <el-button type="primary" size="large" :disabled="$store.state.merchant_disabeld" @click="handleSubmit">
          {{ is_edit ? 'Save' : 'Send invite' }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Modal from '@/components/ui/Modal.vue';
import { ElButton, ElInput, ElSelect, ElOption, ElDialog } from 'element-plus';
export default {
  data() {
    return {
      is_loading: false,
      is_show_add_modal: false,
      is_can_delete: false,
      is_error: false,
      is_staff: 0,
      is_edit: false,

      values: {
        email: '',
        first_name: '',
        last_name: '',
        company_id: 1,
        role_id: 1,
      },
      select_is_staff: [
        { id: 0, text: 'Yes' },
        { id: 1, text: 'No' },
      ],
      key_refrash: 0,
      errors: {},
    };
  },
  props: {
    data: {
      type: Array,
      default: [],
    },

    companys: {
      type: Array,
      default: [],
    },
    roles: {
      type: Array,
      default: [],
    },
  },
  computed: {
    title_name() {
      return this.is_edit ? 'Edit Teammate' : 'Invite Teammate';
    },
    user_company() {
      let company = this.$store.state.user_data.companies.length > 0 ? this.$store.state.user_data.companies : null;
      return company ? company[0].id : '';
    },
  },
  components: {
    Modal,
    ElDialog,
    ElButton,
    ElInput,
    ElSelect,
    ElOption,
  },
  methods: {
    validate() {
      this.errors = {};
      const email = this.values.email.trim();
      const emailsArray = this.data.map((e) => e.email);
      // console.log(' emailsArray', emailsArray);
      if (!email) 
        this.errors.email = 'Email cannot be left blank.';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) 
        this.errors.email = 'Please use the correct email format.';
      else if (this.$ProjectName === 'sephora' && !/@(motom\.me|sephora\.com)$/i.test(email))
        this.errors.email = 'Email must be a <span style="text-decoration: underline;">sephora.com</span> email address.';
      else if (emailsArray.includes(email)) 
        this.errors.email = 'This email is already in use on your team.';

      if (!this.values.first_name.trim()) this.errors.first_name = 'First name cannot be left blank.';
      if (!this.values.last_name.trim()) this.errors.last_name = 'Last name cannot be left blank.';

      return Object.keys(this.errors).length === 0;
    },
    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = '';
      }
    },
    handleSubmit() {
      if (!this.validate()) {
        return;
      }

      this.submit();
    },

    start(data) {
      // console.log(data)
      this.values.role_id = this.roles[1]?.id;
      this.values.company_name = this.companys[0]?.name;
    },

    open(data) {
      this.is_show_add_modal = true;
      this.start(data);
      this.key_refrash += 1;
    },
    close(refrash_api) {
      this.is_show_add_modal = false;
      this.$emit('needRefrash', { refrash_api: refrash_api });
    },

    submit() {
      this.is_loading = true;
      //----------------------
      //make data
      //----------------------
      let form_data = new FormData();
      let api = '';
      let success_mes = '';

      if (this.is_edit) {
        api = '/settings/update-portal-user';
        success_mes = 'Teammate Update';
      } else api = '/settings/invite-user';
      success_mes = 'Teammate invited';

      this.values.company_id = this.companys.find((item) => item.name == this.values.company_name).id;
      for (let key in this.values) {
        if (this.values.hasOwnProperty(key)) {
          form_data.append(key, this.values[key]);
        }
      }

      this.$ajax(api, {
        method: 'post',
        data: form_data,
      })
        .then((res) => {
          this.is_loading = false;
          this.$notify({
            text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
                    </svg> ${success_mes}.`,
            group: 'white',
            type: 'success',
          });
          this.close(true);
        })
        .catch((err) => {
          this.is_loading = false;
          if (err && err.response && err.response.data.data) {
            this.$notify({
              text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
                        </svg> ${err}.`,
              group: 'white',
              type: 'success',
            });
          }
        });
    },
  },
};
</script>
<style lang="scss">
.add-user-modal {
  background-color: var(--bg-02);
  padding: 16px;

  .el-dialog__header {
    span {
      font: var(--font-med-20);
    }
    padding-bottom: 0;
  }

  .user-form-wrap {
    margin-top: 30px;

    input,
    .el-select__input {
      height: 36px;
    }

    .el-select__wrapper {
      min-height: 36px;
    }

    .item-wrap {
      margin: 16px 0;
      position: relative;
      &.item-wrap-2 {
        display: flex;
        align-items: center;
      }

      .item {
        width: calc((100% - 12px) / 2);
        position: relative;

        &:first-child {
          margin-right: 12px;
        }
      }

      .item-2 {
        width: 100%;
        position: relative;
      }
    }

    .label {
      font: var(--font-med-16);
      color: var(--black-90);
      margin-bottom: 4px;

      &:after {
        content: ' *';
        color: var(--alert);
      }
    }

    .label-no-required {
      &:after {
        content: '';
      }
    }

    .value {
      margin: 4px 0 16px;
      font-size: 12px;
      color: var(--black-75);
    }

    .desc {
      font-size: 12px;
      color: var(--black-75);
    }

    .ico-social {
      margin: 12px 0;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: var(--black-75);

      svg {
        height: 14px;
        width: 14px;
        margin-right: 5px;
      }
    }

    .alert-text {
      margin: 12px 0 0;
      padding: 8px;
      font-size: 12px;
      color: var(--black-90);
      background-color: var(--bg-07);
    }
    .error {
      font-size: 12px;
      color: var(--alert);
      text-align: right;
      display: flex;
      align-items: center;
      position: absolute;
      top: 62px;
      right: 0;

      svg {
        width: 10px;
        height: 10px;
        margin-left: 4px;
      }
    }

    .btn-wrap {
      display: flex;
      justify-content: flex-end;

      .ui-button {
        width: 110px;
        text-align: center;
      }
    }
    .el-input.is-error .el-input__wrapper {
      border-color: var(--alert);
      box-shadow: 0 0 0 1px var(--alert);
    }
  }
}
</style>
